<div class="w-full mx-auto h-screen p-5">
  <!-- Header -->
  <div class="bg-white p-6 rounded-lg shadow-sm mb-6">
    <h1 class="text-2xl font-bold text-gray-800">Nuevo Comprobante de Ingreso</h1>
    <p class="text-gray-500 mt-1">Complete la información paso a paso para registrar el pago</p>
  </div>

  <!-- Barra de pasos para wizard -->
  <div class="flex items-center justify-center mb-8">
    <div class="flex w-full max-w-4xl">
      <!-- Pasos normales -->
      <ng-container
        *ngFor="let label of ['Información del Pagador', 'Detalles del Pago', 'Confirmación']; let i = index">
        <div class="flex flex-1 text-center items-center">
          <div class="flex items-center justify-center w-10 h-10 rounded-full" [ngClass]="{
              'bg-blue-500 text-white': step === i + 1,
              'bg-green-500 text-white': step > i + 1,
              'bg-gray-300 text-gray-600': step < i + 1
            }">
            <span *ngIf="step <= i + 1">{{ i + 1 }}</span>
            <svg *ngIf="step > i + 1" class="w-6 h-6" fill="currentColor" viewBox="0 0 20 20">
              <path fill-rule="evenodd"
                d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                clip-rule="evenodd"></path>
            </svg>
          </div>
          <div class="mx-2 flex-1">
            <span class="text-sm font-medium">{{ label }}</span>
          </div>
          <div *ngIf="i < (totalSteps - 1)" class="flex-1 h-0.5 bg-gray-300" [ngClass]="{'bg-blue-500': step > i + 1}">
          </div>
        </div>
      </ng-container>

      <!-- Paso adicional para éxito del link -->
      <div *ngIf="totalSteps === 4" class="flex flex-1 text-center items-center">
        <div class="flex items-center justify-center w-10 h-10 rounded-full" [ngClass]="{
            'bg-blue-500 text-white': step === 4,
            'bg-green-500 text-white': step > 4,
            'bg-gray-300 text-gray-600': step < 4
          }">
          <span *ngIf="step <= 4">4</span>
          <svg *ngIf="step > 4" class="w-6 h-6" fill="currentColor" viewBox="0 0 20 20">
            <path fill-rule="evenodd"
              d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
              clip-rule="evenodd"></path>
          </svg>
        </div>
        <div class="mx-2 flex-1">
          <span class="text-sm font-medium">{{ isLinkGenerated ? '¡Link Generado!' : 'Resultado' }}</span>
        </div>
      </div>
    </div>
  </div>

  <!-- Formulario -->
  <form [formGroup]="incomeReceiptForm" (ngSubmit)="onSubmit()">

    <!-- STEP 1: Información del Pagador -->
    <div *ngIf="step === 1" class="bg-white p-6 rounded-lg shadow-sm mb-6">
      <div class="flex items-center mb-6">
        <div class="w-2 h-8 bg-blue-500 rounded mr-3"></div>
        <h3 class="text-lg font-semibold text-gray-800">Información del Pagador</h3>
      </div>

      <!-- Selector de tipo de pagador -->
      <div class="mb-8">
        <h4 class="text-md font-semibold text-gray-800 mb-4">¿Quién realiza el pago?</h4>

        <div class="grid grid-cols-1 md:grid-cols-3 gap-6">
          <!-- Opción: Participante -->
          <div class="border-2 rounded-xl p-6 cursor-pointer transition-all hover:shadow-lg" [ngClass]="{
                 'border-blue-500 bg-blue-50 shadow-lg': selectedPayerType === PayerType.PARTICIPANT,
                 'border-gray-200 hover:border-gray-300': selectedPayerType !== PayerType.PARTICIPANT
               }" (click)="onPayerTypeChange(PayerType.PARTICIPANT)">

            <div class="flex items-center mb-4">
              <input type="radio" [value]="PayerType.PARTICIPANT"
                [checked]="selectedPayerType === PayerType.PARTICIPANT"
                (change)="onPayerTypeChange(PayerType.PARTICIPANT)" class="text-blue-600 focus:ring-blue-500 mr-3">
              <div class="text-2xl mr-3">👤</div>
              <div>
                <h5 class="text-lg font-bold text-gray-800">Participante</h5>
                <span class="text-sm text-blue-600 font-medium">Pago individual del estudiante</span>
              </div>
            </div>

            <div class="space-y-3 text-sm text-gray-700">
              <div class="flex items-center">
                <svg class="w-4 h-4 text-blue-500 mr-2" fill="currentColor" viewBox="0 0 20 20">
                  <path fill-rule="evenodd"
                    d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                    clip-rule="evenodd"></path>
                </svg>
                <span>El estudiante realiza el pago</span>
              </div>
              <div class="flex items-center">
                <svg class="w-4 h-4 text-blue-500 mr-2" fill="currentColor" viewBox="0 0 20 20">
                  <path fill-rule="evenodd"
                    d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                    clip-rule="evenodd"></path>
                </svg>
                <span>Registro de pago individual</span>
              </div>
            </div>

            <div class="mt-4 p-3 bg-blue-100 rounded-lg">
              <span class="text-blue-800 font-medium text-sm">
                💡 Ideal para inscripciones individuales estándar
              </span>
            </div>
          </div>

          <!-- Opción: Empresa -->
          <div class="border-2 rounded-xl p-6 cursor-pointer transition-all hover:shadow-lg" [ngClass]="{
                 'border-green-500 bg-green-50 shadow-lg': selectedPayerType === PayerType.COMPANY,
                 'border-gray-200 hover:border-gray-300': selectedPayerType !== PayerType.COMPANY
               }" (click)="onPayerTypeChange(PayerType.COMPANY)">

            <div class="flex items-center mb-4">
              <input type="radio" [value]="PayerType.COMPANY" [checked]="selectedPayerType === PayerType.COMPANY"
                (change)="onPayerTypeChange(PayerType.COMPANY)" class="text-green-600 focus:ring-green-500 mr-3">
              <div class="text-2xl mr-3">🏢</div>
              <div>
                <h5 class="text-lg font-bold text-gray-800">Empresa</h5>
                <span class="text-sm text-green-600 font-medium">Pago empresarial</span>
              </div>
            </div>

            <div class="space-y-3 text-sm text-gray-700">
              <div class="flex items-center">
                <svg class="w-4 h-4 text-green-500 mr-2" fill="currentColor" viewBox="0 0 20 20">
                  <path fill-rule="evenodd"
                    d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                    clip-rule="evenodd"></path>
                </svg>
                <span>La empresa realiza el pago</span>
              </div>
              <div class="flex items-center">
                <svg class="w-4 h-4 text-green-500 mr-2" fill="currentColor" viewBox="0 0 20 20">
                  <path fill-rule="evenodd"
                    d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                    clip-rule="evenodd"></path>
                </svg>
                <span>Registro de pago corporativo</span>
              </div>
            </div>

            <div class="mt-4 p-3 bg-green-100 rounded-lg">
              <span class="text-green-800 font-medium text-sm">
                🏢 Ideal para inscripciones corporativas
              </span>
            </div>
          </div>

          <!-- Opción: Participante de una empresa -->
          <div class="border-2 rounded-xl p-6 cursor-pointer transition-all hover:shadow-lg" [ngClass]="{
                 'border-yellow-500 bg-yellow-50 shadow-lg': selectedPayerType === PayerType.PARTICIPANT_CORPORATE,
                 'border-gray-200 hover:border-gray-300': selectedPayerType !== PayerType.PARTICIPANT_CORPORATE
               }" (click)="onPayerTypeChange(PayerType.PARTICIPANT_CORPORATE)">

            <div class="flex items-center mb-4">
              <input type="radio" [value]="PayerType.PARTICIPANT_CORPORATE"
                [checked]="selectedPayerType === PayerType.PARTICIPANT_CORPORATE"
                (change)="onPayerTypeChange(PayerType.PARTICIPANT_CORPORATE)"
                class="text-yellow-600 focus:ring-yellow-500 mr-3">
              <div class="text-2xl mr-3">🤝</div>
              <div>
                <h5 class="text-lg font-bold text-gray-800">Participante de una empresa</h5>
                <span class="text-sm text-yellow-600 font-medium">Pago colaborativo</span>
              </div>
            </div>

            <div class="space-y-3 text-sm text-gray-700">
              <div class="flex items-center">
                <svg class="w-4 h-4 text-yellow-500 mr-2" fill="currentColor" viewBox="0 0 20 20">
                  <path fill-rule="evenodd"
                    d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                    clip-rule="evenodd"></path>
                </svg>
                <span>Pago entre empresa y estudiante</span>
              </div>
              <div class="flex items-center">
                <svg class="w-4 h-4 text-yellow-500 mr-2" fill="currentColor" viewBox="0 0 20 20">
                  <path fill-rule="evenodd"
                    d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                    clip-rule="evenodd"></path>
                </svg>
                <span>Registro de pago mixto</span>
              </div>
            </div>

            <div class="mt-4 p-3 bg-yellow-100 rounded-lg">
              <span class="text-yellow-800 font-medium text-sm">
                🤝 Ideal para acuerdos de cofinanciación
              </span>
            </div>
          </div>
        </div>

        <!-- Descripción de modalidad seleccionada -->
        <div class="mt-6 p-4 bg-blue-50 rounded-lg border border-blue-200">
          <p class="text-blue-800 font-medium">{{ getPayerTypeDescription() }}</p>
        </div>
      </div>

      <!-- Información específica según el tipo de pagador -->
      <div class="grid grid-cols-1 md:grid-cols-2 gap-6">
        <!-- Estudiante (no requerido para tipo COMPANY) -->
        <div *ngIf="selectedPayerType !== PayerType.COMPANY">
          <label for="participantId" class="block text-gray-700 font-bold mb-2" appRequiredLabel>👤 Estudiante</label>
          <p-dropdown id="participantId" formControlName="participantId" [filter]="true" filterBy="label"
            [showClear]="true" [options]="participants" placeholder="Seleccione un estudiante"
            (onChange)="onParticipantChange()" (onFilter)="onSearchParticipants($event)" class="w-full custom-dropdown">
          </p-dropdown>
          <div
            *ngIf="incomeReceiptForm.get('participantId')?.invalid && incomeReceiptForm.get('participantId')?.touched"
            class="text-red-500 text-sm">
            Estudiante es Obligatorio.
          </div>
          <p class="text-xs text-gray-500 mt-1">Estudiante relacionado al pago</p>

          <!-- Mensaje de validación de inscripciones para PARTICIPANT -->
          <div
            *ngIf="selectedPayerType === PayerType.PARTICIPANT && participantHasEnrollments === false && incomeReceiptForm.get('participantId')?.value"
            class="mt-2 p-3 bg-red-50 border border-red-200 rounded-lg">
            <div class="flex items-start">
              <svg class="w-5 h-5 text-red-500 mr-2 mt-0.5" fill="currentColor" viewBox="0 0 20 20">
                <path fill-rule="evenodd"
                  d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 9.586 8.707 8.293z"
                  clip-rule="evenodd"></path>
              </svg>
              <div>
                <p class="text-sm font-semibold text-red-800">⚠️ Sin inscripciones</p>
                <p class="text-xs text-red-600 mt-1">{{ participantEnrollmentCheckMessage }}</p>
              </div>
            </div>
          </div>
        </div>

        <!-- Empresa (solo para COMPANY y SHARED) -->
        <div *ngIf="selectedPayerType === PayerType.COMPANY || selectedPayerType === PayerType.PARTICIPANT_CORPORATE">
          <label for="companyId" class="block text-gray-700 font-bold mb-2" appRequiredLabel>🏢 Empresa</label>
          <p-dropdown id="companyId" formControlName="companyId" [filter]="true" filterBy="label" [showClear]="true"
            [options]="companies" [placeholder]="selectedPayerType === PayerType.PARTICIPANT_CORPORATE && (!incomeReceiptForm.get('participantId')?.value || incomeReceiptForm.get('participantId')?.value === 0) 
                           ? 'Primero seleccione un participante' 
                           : 'Seleccione una empresa'" [(ngModel)]="selectedCompanyId" (onChange)="onCompanyChange()"
            (onFilter)="onSearchCompanies($event)"
            [disabled]="selectedPayerType === PayerType.PARTICIPANT_CORPORATE && (!incomeReceiptForm.get('participantId')?.value || incomeReceiptForm.get('participantId')?.value === 0)"
            class="w-full custom-dropdown">
          </p-dropdown>
          <div *ngIf="incomeReceiptForm.get('companyId')?.invalid && incomeReceiptForm.get('companyId')?.touched"
            class="text-red-500 text-sm">
            Empresa es Obligatoria para este tipo de pago.
          </div>
          <!-- 🆕 Mensaje informativo para modo PARTICIPANT_CORPORATE -->
          <p *ngIf="selectedPayerType === PayerType.PARTICIPANT_CORPORATE"
            class="text-xs text-blue-600 mt-1 font-medium">
            <span
              *ngIf="!incomeReceiptForm.get('participantId')?.value || incomeReceiptForm.get('participantId')?.value === 0">
              ⚠️ Seleccione primero un participante para ver sus empresas asociadas
            </span>
            <span
              *ngIf="incomeReceiptForm.get('participantId')?.value && incomeReceiptForm.get('participantId')?.value !== 0 && companies.length === 0">
              ℹ️ Este participante no tiene inscripciones en ninguna empresa
            </span>
            <span
              *ngIf="incomeReceiptForm.get('participantId')?.value && incomeReceiptForm.get('participantId')?.value !== 0 && companies.length > 0">
              ✅ Mostrando solo empresas donde el participante tiene inscripciones ({{ companies.length }})
            </span>
          </p>
          <p *ngIf="selectedPayerType === PayerType.COMPANY" class="text-xs text-gray-500 mt-1">
            Empresa que realiza el pago
          </p>

          <!-- Mensaje de validación de inscripciones para COMPANY -->
          <div *ngIf="selectedPayerType === PayerType.COMPANY && companyHasEnrollments === false && selectedCompanyId"
            class="mt-2 p-3 bg-red-50 border border-red-200 rounded-lg">
            <div class="flex items-start">
              <svg class="w-5 h-5 text-red-500 mr-2 mt-0.5" fill="currentColor" viewBox="0 0 20 20">
                <path fill-rule="evenodd"
                  d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 9.586 8.707 8.293z"
                  clip-rule="evenodd"></path>
              </svg>
              <div>
                <p class="text-sm font-semibold text-red-800">⚠️ Sin inscripciones corporativas</p>
                <p class="text-xs text-red-600 mt-1">{{ companyEnrollmentCheckMessage }}</p>
              </div>
            </div>
          </div>
        </div>

        <!-- Mensaje de validación de inscripciones para PARTICIPANT_CORPORATE -->
        <div
          *ngIf="selectedPayerType === PayerType.PARTICIPANT_CORPORATE && participantHasEnrollments === false && incomeReceiptForm.get('participantId')?.value && incomeReceiptForm.get('participantId')?.value !== 0"
          class="mt-4 p-3 bg-red-50 border border-red-200 rounded-lg">
          <div class="flex items-start">
            <svg class="w-5 h-5 text-red-500 mr-2 mt-0.5" fill="currentColor" viewBox="0 0 20 20">
              <path fill-rule="evenodd"
                d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 9.586 8.707 8.293z"
                clip-rule="evenodd"></path>
            </svg>
            <div>
              <p class="text-sm font-semibold text-red-800">⚠️ Sin inscripciones corporativas</p>
              <p class="text-xs text-red-600 mt-1">{{ participantEnrollmentCheckMessage }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- STEP 2: Detalles del Pago -->
    <div *ngIf="step === 2" class="bg-white p-6 rounded-lg shadow-sm mb-6">
      <div class="flex items-center mb-6">
        <div class="w-2 h-8 bg-blue-500 rounded mr-3"></div>
        <h3 class="text-lg font-semibold text-gray-800">Detalles del Pago</h3>
      </div>

      <!-- Resumen del pagador seleccionado -->
      <div class="bg-gradient-to-r from-blue-50 to-indigo-50 p-6 rounded-xl border border-blue-200 mb-8">
        <h4 class="text-lg font-bold text-gray-800 mb-4 flex items-center">
          <span class="text-2xl mr-2">{{ selectedPayerType === PayerType.COMPANY ? '🏢' : selectedPayerType ===
            PayerType.PARTICIPANT_CORPORATE ? '🤝' : '👤' }}</span>
          Información del Pagador
        </h4>

        <div class="grid grid-cols-1 md:grid-cols-2 gap-6">
          <div class="bg-white p-4 rounded-lg border shadow-sm">
            <div class="text-sm font-medium text-gray-600 mb-2">Tipo de Pagador</div>
            <div class="text-lg font-bold text-gray-800">{{ getPayerTypeDisplayName() }}</div>
          </div>
          <div class="bg-white p-4 rounded-lg border shadow-sm" *ngIf="getSelectedParticipant()">
            <div class="text-sm font-medium text-gray-600 mb-2">Estudiante</div>
            <div class="text-lg font-bold text-gray-800">{{ getSelectedParticipant()?.label }}</div>
          </div>
          <div class="bg-white p-4 rounded-lg border shadow-sm" *ngIf="getSelectedCompany()">
            <div class="text-sm font-medium text-gray-600 mb-2">Empresa</div>
            <div class="text-lg font-bold text-gray-800">{{ getSelectedCompany()?.label }}</div>
          </div>
        </div>
      </div>

      <div class="grid grid-cols-1 md:grid-cols-2 gap-6">
        <!-- Proyecto -->
        <div>
          <label for="projectId" class="block text-gray-700 font-bold mb-2" appRequiredLabel>Proyecto</label>
          <p-dropdown [filter]="true" id="projectId" formControlName="projectId" filterBy="label" [showClear]="true"
            [options]="projects" optionLabel="label" optionValue="value" placeholder="Seleccione un proyecto"
            (onChange)="handleGetPaymentPlansByProject($event)" (onFilter)="onSearchProjects($event)"
            class="w-full custom-dropdown">
          </p-dropdown>
          <div *ngIf="incomeReceiptForm.get('projectId')?.invalid && incomeReceiptForm.get('projectId')?.touched"
            class="text-red-500 text-sm">
            Proyecto es Obligatorio.
          </div>
        </div>

        <!-- Concepto -->
        <div>
          <label for="concept" class="block text-gray-700 font-bold mb-2" appRequiredLabel>
            Concepto
          </label>
          <p-dropdown id="concept" formControlName="concept" [filter]="true" filterBy="label" [showClear]="true"
            [options]="conceptOptions" optionLabel="label" optionValue="value" placeholder="Seleccione un concepto"
            class="w-full custom-dropdown">
          </p-dropdown>
          <div *ngIf="incomeReceiptForm.get('concept')?.invalid && incomeReceiptForm.get('concept')?.touched"
            class="text-red-500 text-sm">
            Concepto es Obligatorio.
          </div>
        </div>

        <!-- Método de Pago -->
        <div>
          <label for="paymentMethodId" class="block text-gray-700 font-bold mb-2" appRequiredLabel>Método de
            Pago</label>
          <p-dropdown id="paymentMethodId" formControlName="paymentMethodId" [filter]="true" filterBy="label"
            [showClear]="true" [options]="filteredPaymentMethods" placeholder="Seleccione un método de Pago"
            (onChange)="onPaymentMethodChange()" class="w-full custom-dropdown">
          </p-dropdown>
          <div
            *ngIf="incomeReceiptForm.get('paymentMethodId')?.invalid && incomeReceiptForm.get('paymentMethodId')?.touched"
            class="text-red-500 text-sm">
            Método de Pago es Obligatorio.
          </div>
        </div>

        <!-- Banco -->
        <div>
          <label for="bankId" class="block text-gray-700 font-bold mb-2" appRequiredLabel>Banco</label>
          <p-dropdown id="bankId" formControlName="bankId" [filter]="true" filterBy="label" [showClear]="true"
            [options]="banks" placeholder="Seleccione un banco" class="w-full custom-dropdown">
          </p-dropdown>
          <div *ngIf="incomeReceiptForm.get('bankId')?.invalid && incomeReceiptForm.get('bankId')?.touched"
            class="text-red-500 text-sm">
            Banco es Obligatorio.
          </div>
        </div>

        <!-- Categoría de Ingreso -->
        <div>
          <label for="projectBudgetId" class="block text-gray-700 font-bold mb-2" appRequiredLabel>Categoría de
            Ingreso</label>
          <p-dropdown [filter]="true" id="projectBudgetId" formControlName="projectBudgetId" filterBy="label"
            [showClear]="true" [options]="incomeProjectBudgets" placeholder="Seleccione una categoría de ingreso"
            class="w-full custom-dropdown">
          </p-dropdown>
          <div
            *ngIf="incomeReceiptForm.get('projectBudgetId')?.invalid && incomeReceiptForm.get('projectBudgetId')?.touched"
            class="text-red-500 text-sm">
            Categoría de Ingreso es Obligatoria.
          </div>
        </div>

        <!-- Número de Referencia -->
        <div *ngIf="incomeReceiptForm.get('paymentMethodId')?.value == 1">
          <label for="referenceNumber" class="block text-gray-700 font-bold mb-2">Número de Referencia</label>
          <input type="text" formControlName="referenceNumber" class="w-full px-3 py-2 border rounded-md" />
        </div>

        <!-- Fecha en la que ingresó el pago -->
        <div>
          <label for="transactionDate" class="block text-gray-700 font-bold mb-2" appRequiredLabel>Fecha en la que
            ingresó el pago</label>
          <p-calendar formControlName="transactionDate" [showIcon]="true" dateFormat="dd/mm/yy" appendTo="body"
            styleClass="w-full" inputStyleClass="w-full px-3 py-2 border rounded-md"
            [disabled]="isWompiPaymentMethod()"></p-calendar>
          <div
            *ngIf="incomeReceiptForm.get('transactionDate')?.invalid && incomeReceiptForm.get('transactionDate')?.touched"
            class="text-red-500 text-sm">
            Fecha es Obligatoria.
          </div>
        </div>
      </div>

      <!-- PaymentPlanId -->
      <div class="mt-6" *ngIf="shouldShowPaymentPlan()">
        <label for="paymentPlanId" class="block text-gray-700 font-bold mb-2" appRequiredLabel>Cuota a Pagar</label>
        <p-dropdown [filter]="true" filterBy="label" [showClear]="!isEditMode" [options]="paymentsPlans"
          placeholder="Seleccione la cuota a pagar" formControlName="paymentPlanId"
          (onChange)="handleGetGrossAmountPaymentPlan($event)" class="w-full custom-dropdown" [disabled]="isEditMode">
          <ng-template let-plan pTemplate="item">
            <div class="p-2" [ngClass]="{'opacity-60': plan.disabled}">
              <div class="font-semibold"
                [ngClass]="{'text-red-600': plan.data.isPunished, 'text-blue-600': !plan.data.isPunished}">
                <span *ngIf="plan.data.isPunished">🚫 (CASTIGADA) </span>
                Cuota {{plan.data.installmentNumber}} - {{plan.data.paymentStatus}}
              </div>
              <div class="text-sm text-gray-600 mt-1">
                <div class="grid grid-cols-2 gap-2">
                  <div>
                    <strong>Monto a Pagar:</strong>
                    <div class="text-blue-700">{{formatCurrencyFromPlan(plan.data.amountToPay, plan.data)}}</div>
                  </div>
                  <div>
                    <strong>Monto Pagado:</strong>
                    <div class="text-green-700">{{formatCurrencyFromPlan(plan.data.amountPaid, plan.data)}}</div>
                  </div>
                  <div>
                    <strong>Pendiente:</strong>
                    <div class="text-orange-700">{{formatCurrencyFromPlan(plan.data.pendingPayment, plan.data)}}</div>
                  </div>
                  <div>
                    <strong>Vencimiento:</strong>
                    <div>{{plan.data.dueDate | date:'dd/MM/yyyy'}}</div>
                  </div>
                </div>
                <div
                  *ngIf="selectedEnrollmentInfo?.currencyCode !== 'COP' && currentExchangeRate && currentExchangeRate !== 1"
                  class="mt-2 text-xs text-purple-600 bg-purple-50 p-2 rounded">
                  💱 Tasa de cambio: {{currentExchangeRate | number:'1.2-4'}} ({{selectedEnrollmentInfo?.currencyCode}}
                  → COP)
                </div>
                <div *ngIf="plan.data.isPunished"
                  class="mt-2 text-xs text-red-600 bg-red-50 p-2 rounded border border-red-200 font-bold">
                  ⚠️ Esta cuota está castigada y no puede seleccionarse para comprobante de ingreso.
                </div>
              </div>
            </div>
          </ng-template>
        </p-dropdown>

        <div
          *ngIf="incomeReceiptForm.get('paymentPlanId')?.invalid && incomeReceiptForm.get('paymentPlanId')?.touched"
          class="text-red-500 text-sm mt-1">
          Debe seleccionar una cuota para generar el link de pago con Wompi.
        </div>

        <!-- Selector de pagador cuando hay split -->
        <div *ngIf="planAllocations?.length > 1" class="mt-3 p-3 bg-gray-50 border rounded">
          <div class="text-sm text-gray-700 font-semibold mb-2">Quién paga esta cuota</div>
          <div class="flex gap-4">
            <label class="inline-flex items-center gap-2 cursor-pointer">
              <input type="radio" name="payerSelect" (change)="onChangePayerSelection('PARTICIPANT')"
                [checked]="payerSelection==='PARTICIPANT'">
              <span>Estudiante</span>
            </label>
            <label class="inline-flex items-center gap-2 cursor-pointer">
              <input type="radio" name="payerSelect" (change)="onChangePayerSelection('COMPANY')"
                [checked]="payerSelection==='COMPANY'">
              <span>Empresa</span>
            </label>
          </div>
        </div>
      </div>

      <!-- Aviso de campos no editables en modo edición -->
      <div *ngIf="isEditMode" class="mt-4 p-3 bg-amber-50 border border-amber-300 rounded-md text-sm text-amber-800">
        ⚠️ El <strong>valor a pagar</strong> no se puede modificar al editar un comprobante.
      </div>

      <!-- GrossAmount -->
      <div class="mt-6">
        <label for="grossAmount" class="block text-gray-700 font-bold mb-2">
          Valor a Pagar
          <span *ngIf="getCurrencyCode() !== 'COP'" class="text-sm font-normal text-gray-500">
            ({{getCurrencyCode()}})
          </span>
          <span *ngIf="getCurrencyCode() === 'COP'" class="text-sm font-normal text-gray-500">
            (COP)
          </span>
        </label>
        <input type="text" appCurrencyFormatter formControlName="grossAmount" (input)="calculateCOPEquivalent()"
          class="w-full px-3 py-2 border rounded-md" [readonly]="isEditMode" [class.bg-gray-100]="isEditMode"
          [class.cursor-not-allowed]="isEditMode" />
        <div *ngIf="incomeReceiptForm.get('grossAmount')?.invalid && incomeReceiptForm.get('grossAmount')?.touched"
          class="text-red-500 text-sm">
          Monto es Obligatorio.
        </div>
      </div>

      <!-- Campo informativo - Equivalente en COP -->
      <div class="mt-4" *ngIf="selectedEnrollmentInfo?.currencyCode !== 'COP' && copEquivalent > 0">
        <label class="block text-gray-700 font-bold mb-2">Equivalente en COP (Informativo)</label>
        <div class="p-3 bg-gray-50 border border-gray-300 rounded-md">
          <div class="flex justify-between items-center">
            <span class="text-lg font-semibold text-green-600">
              {{formatCurrency(copEquivalent, 'COP')}}
            </span>
            <span class="text-sm text-gray-500">
              Tasa: {{currentExchangeRate | number:'1.2-4'}}
            </span>
          </div>
          <p class="text-xs text-gray-500 mt-1">
            * Este valor es solo informativo y se calcula automáticamente
          </p>
        </div>
      </div>

      <!-- Observaciones -->
      <div class="mt-6">
        <label for="observations" class="block text-gray-700 font-bold mb-2">Observaciones</label>
        <textarea formControlName="observations" class="w-full px-3 py-2 border rounded-md resize-none" rows="3"
          placeholder="Observaciones adicionales (opcional)"></textarea>
      </div>

      <!-- Fee Details Section -->
      <div class="mt-6 p-4 border rounded-lg shadow-sm">
        <h2 class="text-lg font-semibold mb-4">Descuentos</h2>

        <button type="button" (click)="addFeeDetail()"
          class="px-4 py-2 bg-blue-500 text-white rounded-md mb-4 hover:bg-blue-600 transition-colors"
          [disabled]="isLinkPayment()">
          Agregar Fee
        </button>

        <!-- Mensaje informativo cuando es link de pago -->
        <div *ngIf="isLinkPayment()" class="mb-4 p-3 bg-yellow-50 border border-yellow-200 rounded-lg">
          <div class="flex items-center text-sm text-yellow-800">
            <svg class="w-5 h-5 mr-2" fill="currentColor" viewBox="0 0 20 20">
              <path fill-rule="evenodd"
                d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z"
                clip-rule="evenodd"></path>
            </svg>
            <span>ℹ️ Los descuentos no están disponibles para links de pago</span>
          </div>
        </div>

        <div formArrayName="feeDetails">
          <div *ngFor="let fee of feeDetails.controls; let i = index" [formGroupName]="i"
            class="mt-4 border p-4 rounded-lg shadow">
            <div class="grid grid-cols-1 md:grid-cols-3 gap-4">
              <!-- Tipo de Fee -->
              <div>
                <label class="block text-gray-700 font-semibold mb-2">Tipo de Fee</label>
                <select formControlName="feeTypeId" class="w-full px-3 py-2 border rounded-md">
                  <option value="" disabled selected>Seleccione un tipo</option>
                  <option *ngFor="let type of feeTypes" [value]="type.id">{{ type.name }}</option>
                </select>
              </div>

              <!-- Monto -->
              <div>
                <label class="block text-gray-700 font-semibold mb-2">Monto</label>
                <input type="text" formControlName="requestAmount" class="w-full px-3 py-2 border rounded-md" />
                <span class="text-xs text-gray-500">Valor fijo ej: 50000, o porcentaje ej: 10%</span>
              </div>

              <!-- Descripción -->
              <div>
                <label class="block text-gray-700 font-semibold mb-2">Descripción</label>
                <input type="text" formControlName="description" class="w-full px-3 py-2 border rounded-md" />
              </div>
            </div>

            <!-- Botón eliminar -->
            <button type="button" (click)="removeFeeDetail(i)"
              class="mt-3 px-4 py-2 bg-red-500 text-white rounded-lg hover:bg-red-600">
              Eliminar
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- STEP 3: Confirmación y Resumen -->
    <div *ngIf="step === 3" class="bg-white p-6 rounded-lg shadow-sm mb-6">
      <div class="flex items-center mb-6">
        <div class="w-2 h-8 bg-green-500 rounded mr-3"></div>
        <h3 class="text-lg font-semibold text-gray-800">Confirmación y Resumen</h3>
      </div>

      <!-- Resumen completo del comprobante -->
      <div class="bg-gradient-to-br from-green-50 to-emerald-50 p-6 rounded-xl border border-green-200 mb-6">
        <div class="flex items-center justify-between mb-6">
          <h4 class="text-xl font-bold text-gray-800">📋 Resumen del Comprobante de Ingreso</h4>
          <div class="flex space-x-2">
            <span class="bg-green-100 text-green-800 px-3 py-1 rounded-full text-sm font-medium">
              {{ getPayerTypeDisplayName() }}
            </span>
          </div>
        </div>

        <!-- Información del pagador -->
        <div class="grid grid-cols-1 md:grid-cols-2 gap-6 mb-6">
          <div class="bg-white p-4 rounded-lg shadow-sm">
            <h5 class="font-semibold text-gray-800 mb-3">{{ selectedPayerType === PayerType.COMPANY ? '🏢' :
              selectedPayerType === PayerType.PARTICIPANT_CORPORATE ? '🤝' : '👤' }} Información del Pagador</h5>
            <div class="space-y-2 text-sm">
              <div class="flex justify-between">
                <span class="text-gray-600">Tipo de Pago:</span>
                <span class="font-semibold">{{ getPayerTypeDisplayName() }}</span>
              </div>
              <div class="flex justify-between" *ngIf="getSelectedParticipant()">
                <span class="text-gray-600">Estudiante:</span>
                <span class="font-semibold">{{ getSelectedParticipant()?.label }}</span>
              </div>
              <div class="flex justify-between" *ngIf="getSelectedCompany()">
                <span class="text-gray-600">Empresa:</span>
                <span class="font-semibold">{{ getSelectedCompany()?.label }}</span>
              </div>
            </div>
          </div>

          <div class="bg-white p-4 rounded-lg shadow-sm">
            <h5 class="font-semibold text-gray-800 mb-3">💰 Información del Pago</h5>
            <div class="space-y-2 text-sm">
              <div class="flex justify-between">
                <span class="text-gray-600">Concepto:</span>
                <span class="font-semibold">{{ getSelectedConceptLabel() }}</span>
              </div>
              <div class="flex justify-between">
                <span class="text-gray-600">Método de Pago:</span>
                <span class="font-semibold">{{ getSelectedPaymentMethodName() }}</span>
              </div>
              <div class="flex justify-between">
                <span class="text-gray-600">Monto:</span>
                <span class="font-semibold text-green-600">{{ getFormattedGrossAmount() }}</span>
              </div>
              <div class="flex justify-between">
                <span class="text-gray-600">Proyecto:</span>
                <span class="font-semibold">{{ getSelectedProjectLabel() }}</span>
              </div>
              <div class="flex justify-between">
                <span class="text-gray-600">Banco:</span>
                <span class="font-semibold">{{ getSelectedBankLabel() }}</span>
              </div>
              <div class="flex justify-between">
                <span class="text-gray-600">Categoría de Ingreso:</span>
                <span class="font-semibold">{{ getSelectedIncomeCategoryLabel() }}</span>
              </div>
              <div class="flex justify-between" *ngIf="incomeReceiptForm.get('paymentMethodId')?.value == 1 && getReferenceNumber()">
                <span class="text-gray-600">Número de Referencia:</span>
                <span class="font-semibold">{{ getReferenceNumber() }}</span>
              </div>
              <div class="flex justify-between">
                <span class="text-gray-600">Fecha de Pago:</span>
                <span class="font-semibold">{{ incomeReceiptForm.get('transactionDate')?.value | date:'dd/MM/yyyy' }}</span>
              </div>
              <div class="flex justify-between" *ngIf="shouldShowPaymentPlan()">
                <span class="text-gray-600">Cuota a Pagar:</span>
                <span class="font-semibold">{{ getSelectedPaymentPlanLabel() }}</span>
              </div>
            </div>
          </div>
        </div>

        <!-- Descuentos/Fees si los hay -->
        <div *ngIf="feeDetails.length > 0" class="bg-white p-4 rounded-lg shadow-sm mb-6">
          <h5 class="font-semibold text-gray-800 mb-3">💲 Descuentos / Fees</h5>
          <div class="space-y-2 text-sm">
            <div *ngFor="let fee of feeDetails.controls" class="flex justify-between items-start border-b border-gray-100 pb-2">
              <div class="flex flex-col">
                <span class="text-gray-700 font-medium">{{ getSelectedFeeTypeName(fee.get('feeTypeId')?.value) }}</span>
                <span *ngIf="fee.get('description')?.value" class="text-xs text-gray-500">{{ fee.get('description')?.value }}</span>
              </div>
              <span class="font-semibold text-red-600">{{ fee.get('requestAmount')?.value }}</span>
            </div>
          </div>
        </div>

        <!-- Equivalente en COP si aplica -->
        <div *ngIf="isNonCOPCurrency()" class="bg-white p-4 rounded-lg shadow-sm border-l-4 border-blue-500 mb-6">
          <h5 class="font-semibold text-gray-800 mb-2">💱 Información de Cambio de Moneda</h5>
          <div class="grid grid-cols-1 md:grid-cols-3 gap-4 text-sm">
            <div>
              <span class="text-gray-600">Moneda Original:</span>
              <div class="font-semibold">{{ getCurrentCurrencyCode() }}</div>
            </div>
            <div>
              <span class="text-gray-600">Tasa de Cambio:</span>
              <div class="font-semibold">{{ currentExchangeRate | number:'1.2-4' }}</div>
            </div>
            <div>
              <span class="text-gray-600">Equivalente COP:</span>
              <div class="font-semibold text-green-600">{{ formatCurrency(copEquivalent, 'COP') }}</div>
            </div>
          </div>
        </div>

        <!-- Observaciones si las hay -->
        <div *ngIf="getObservations()" class="bg-white p-4 rounded-lg shadow-sm">
          <h5 class="font-semibold text-gray-800 mb-2">📝 Observaciones:</h5>
          <p class="text-sm text-gray-700">{{ getObservations() }}</p>
        </div>

        <!-- 🆕 Justificación de Edición (solo en modo edición) -->
        <div *ngIf="isEditMode" class="bg-white p-4 rounded-lg shadow-sm border-l-4 border-orange-500 mt-4">
          <h5 class="font-semibold text-orange-800 mb-2">✏️ Justificación de la Edición <span
              class="text-red-500">*</span></h5>
          <p class="text-sm text-gray-600 mb-3">Explique por qué se requiere esta edición. La nueva versión quedará
            pendiente de aprobación.</p>
          <textarea [(ngModel)]="editJustification" [ngModelOptions]="{standalone: true}"
            class="w-full px-3 py-2 border border-orange-300 rounded-md resize-none focus:ring-2 focus:ring-orange-500 focus:border-orange-500"
            rows="3"
            placeholder="Ej: Corrección del monto por error de digitación, cambio de método de pago, etc."></textarea>
          <div *ngIf="editJustification.length === 0" class="text-orange-600 text-xs mt-1">
            La justificación es requerida para enviar la edición.
          </div>
        </div>

        <!-- 🆕 Banner informativo de edición -->
        <div *ngIf="isEditMode" class="mt-6 p-4 bg-orange-50 rounded-lg border border-orange-200">
          <div class="flex items-start">
            <svg class="w-6 h-6 text-orange-600 mr-3 mt-0.5" fill="currentColor" viewBox="0 0 20 20">
              <path fill-rule="evenodd"
                d="M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z"
                clip-rule="evenodd"></path>
            </svg>
            <div>
              <h6 class="font-semibold text-orange-800 mb-1">⚠️ Edición Pendiente de Aprobación</h6>
              <p class="text-sm text-orange-700">
                Al enviar esta edición, se creará una nueva versión del comprobante que quedará pendiente de aprobación.
                El comprobante original no será afectado hasta que la nueva versión sea aprobada por un usuario
                autorizado.
              </p>
            </div>
          </div>
        </div>

        <!-- Confirmación final (solo si no es edición) -->
        <div *ngIf="!isEditMode" class="mt-6 p-4 bg-yellow-50 rounded-lg border border-yellow-200">
          <div class="flex items-start">
            <svg class="w-6 h-6 text-yellow-600 mr-3 mt-0.5" fill="currentColor" viewBox="0 0 20 20">
              <path fill-rule="evenodd"
                d="M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z"
                clip-rule="evenodd"></path>
            </svg>
            <div>
              <h6 class="font-semibold text-yellow-800 mb-1">⚠️ Confirmación Requerida</h6>
              <p class="text-sm text-yellow-700">
                Al hacer clic en "Crear Comprobante", se procesará el registro del pago.
                Verifique que toda la información esté correcta antes de continuar.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- STEP 4: Pantalla de Éxito del Link Generado -->
    <div *ngIf="step === 4 && isLinkGenerated" class="bg-white p-6 rounded-lg shadow-sm mb-6">
      <div class="flex items-center mb-6">
        <div class="w-2 h-8 bg-green-500 rounded mr-3"></div>
        <h3 class="text-lg font-semibold text-gray-800">¡Link de Pago Generado Exitosamente!</h3>
      </div>

      <!-- Mensaje de éxito principal -->
      <div class="bg-gradient-to-r from-green-50 to-emerald-50 p-6 rounded-xl border border-green-200 mb-6">
        <div class="flex items-center mb-4">
          <div class="flex-shrink-0">
            <svg class="w-12 h-12 text-green-500" fill="currentColor" viewBox="0 0 20 20">
              <path fill-rule="evenodd"
                d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
                clip-rule="evenodd"></path>
            </svg>
          </div>
          <div class="ml-4">
            <h4 class="text-xl font-bold text-green-800 mb-2">🎉 ¡Todo listo!</h4>
            <p class="text-green-700">
              El link de pago se ha creado correctamente y se ha enviado automáticamente al correo correspondiente.
            </p>
          </div>
        </div>

        <!-- Información del email enviado -->
        <div class="bg-white p-4 rounded-lg border border-green-200">
          <div class="flex items-center">
            <svg class="w-6 h-6 text-blue-500 mr-3" fill="currentColor" viewBox="0 0 20 20">
              <path d="M2.003 5.884L10 9.882l7.997-3.998A2 2 0 0016 4H4a2 2 0 00-1.997 1.884z"></path>
              <path d="M18 8.118l-8 4-8-4V14a2 2 0 002 2h12a2 2 0 002-2V8.118z"></path>
            </svg>
            <span class="text-sm font-medium text-gray-800">
              📧 Email enviado automáticamente con la información del pago
            </span>
          </div>
        </div>
      </div>

      <!-- Información detallada del link -->
      <div class="grid grid-cols-1 md:grid-cols-2 gap-6 mb-6">
        <!-- Información del link -->
        <div class="bg-blue-50 p-6 rounded-lg border border-blue-200">
          <h5 class="font-semibold text-blue-800 mb-4 flex items-center">
            <svg class="w-6 h-6 mr-2" fill="currentColor" viewBox="0 0 20 20">
              <path fill-rule="evenodd"
                d="M12.586 4.586a2 2 0 112.828 2.828l-3 3a2 2 0 01-2.828 0 1 1 0 00-1.414 1.414 4 4 0 005.656 0l3-3a4 4 0 00-5.656-5.656l-1.5 1.5a1 1 0 101.414 1.414l1.5-1.5zm-5 5a2 2 0 012.828 0 1 1 0 101.414-1.414 4 4 0 00-5.656 0l-3 3a4 4 0 105.656 5.656l1.5-1.5a1 1 0 10-1.414-1.414l-1.5 1.5a2 2 0 11-2.828-2.828l3-3z"
                clip-rule="evenodd"></path>
            </svg>
            Información del Link
          </h5>
          <div class="space-y-3">
            <div>
              <span class="text-sm font-medium text-blue-600">ID del Link:</span>
              <div class="font-mono text-sm bg-white p-2 rounded border">
                {{ generatedPaymentLink?.wompiLinkId || 'N/A' }}
              </div>
            </div>
            <div>
              <span class="text-sm font-medium text-blue-600">Monto:</span>
              <div class="text-lg font-bold text-green-600">
                {{ getFormattedLinkAmount() }}
              </div>
            </div>
            <div>
              <span class="text-sm font-medium text-blue-600">Fecha de Creación:</span>
              <div class="text-sm text-gray-700">
                {{ generatedPaymentLink?.generatedDate | date:'medium' }}
              </div>
            </div>
          </div>
        </div>

        <!-- Información de vencimiento -->
        <div class="bg-yellow-50 p-6 rounded-lg border border-yellow-200"
          [ngClass]="{'bg-red-50 border-red-200': isLinkExpiringSoon()}">
          <h5 class="font-semibold mb-4 flex items-center"
            [ngClass]="{'text-yellow-800': !isLinkExpiringSoon(), 'text-red-800': isLinkExpiringSoon()}">
            <svg class="w-6 h-6 mr-2" fill="currentColor" viewBox="0 0 20 20">
              <path fill-rule="evenodd"
                d="M10 18a8 8 0 100-16 8 8 0 000 16zm1-12a1 1 0 10-2 0v4a1 1 0 00.293.707l2.828 2.829a1 1 0 101.415-1.415L11 9.586V6z"
                clip-rule="evenodd"></path>
            </svg>
            ⏰ Vencimiento del Link
          </h5>
          <div class="space-y-3">
            <div>
              <span class="text-sm font-medium"
                [ngClass]="{'text-yellow-600': !isLinkExpiringSoon(), 'text-red-600': isLinkExpiringSoon()}">
                Fecha de Expiración:
              </span>
              <div class="font-semibold"
                [ngClass]="{'text-yellow-800': !isLinkExpiringSoon(), 'text-red-800': isLinkExpiringSoon()}">
                {{ getFormattedExpirationDate() }}
              </div>
            </div>
            <div *ngIf="isLinkExpiringSoon()" class="bg-red-100 p-3 rounded border border-red-200">
              <div class="flex items-center">
                <svg class="w-5 h-5 text-red-500 mr-2" fill="currentColor" viewBox="0 0 20 20">
                  <path fill-rule="evenodd"
                    d="M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z"
                    clip-rule="evenodd"></path>
                </svg>
                <span class="text-sm font-medium text-red-700">
                  ⚠️ El link expira en menos de 24 horas
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Link para copiar -->
      <div class="bg-white p-6 rounded-lg border border-gray-200 shadow-sm mb-6">
        <h5 class="font-semibold text-gray-800 mb-4 flex items-center">
          <svg class="w-6 h-6 text-blue-500 mr-2" fill="currentColor" viewBox="0 0 20 20">
            <path fill-rule="evenodd"
              d="M12.586 4.586a2 2 0 112.828 2.828l-3 3a2 2 0 01-2.828 0 1 1 0 00-1.414 1.414 4 4 0 005.656 0l3-3a4 4 0 00-5.656-5.656l-1.5 1.5a1 1 0 101.414 1.414l1.5-1.5zm-5 5a2 2 0 012.828 0 1 1 0 101.414-1.414 4 4 0 00-5.656 0l-3 3a4 4 0 105.656 5.656l1.5-1.5a1 1 0 10-1.414-1.414l-1.5 1.5a2 2 0 11-2.828-2.828l3-3z"
              clip-rule="evenodd"></path>
          </svg>
          🔗 Link de Pago
        </h5>

        <!-- Campo para mostrar el link -->
        <div class="flex flex-col md:flex-row gap-3">
          <div class="flex-1">
            <input type="text" readonly [value]="generatedPaymentLink?.paymentUrl || ''"
              class="w-full px-4 py-3 bg-gray-50 border border-gray-300 rounded-lg font-mono text-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
              placeholder="Link de pago...">
          </div>
          <button type="button" (click)="copyPaymentLink()"
            class="px-6 py-3 bg-blue-600 hover:bg-blue-700 text-white font-semibold rounded-lg transition-colors duration-200 flex items-center gap-2 shadow-sm hover:shadow-md">
            <svg class="w-5 h-5" fill="currentColor" viewBox="0 0 20 20">
              <path d="M8 3a1 1 0 011-1h2a1 1 0 110 2H9a1 1 0 01-1-1z"></path>
              <path d="M6 3a2 2 0 00-2 2v11a2 2 0 002 2h8a2 2 0 002-2V5a2 2 0 00-2-2 3 3 0 01-3 3H9a3 3 0 01-3-3z">
              </path>
            </svg>
            Copiar Link
          </button>
        </div>

        <!-- Información adicional -->
        <div class="mt-4 p-4 bg-blue-50 rounded-lg border border-blue-200">
          <div class="flex items-start">
            <svg class="w-5 h-5 text-blue-600 mr-2 mt-0.5" fill="currentColor" viewBox="0 0 20 20">
              <path fill-rule="evenodd"
                d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z"
                clip-rule="evenodd"></path>
            </svg>
            <div class="text-sm text-blue-800">
              <p class="font-medium mb-1">💡 Información importante:</p>
              <ul class="list-disc list-inside space-y-1">
                <li>El link se ha enviado automáticamente por email al destinatario</li>
                <li>Puede compartir este link de forma segura</li>
                <li>El pago se procesará directamente a través de la plataforma Wompi</li>
                <li>Recibirá una confirmación automática una vez completado el pago</li>
              </ul>
            </div>
          </div>
        </div>
      </div>

      <!-- Resumen de la transacción -->
      <div class="bg-gray-50 p-6 rounded-lg border border-gray-200 mb-6">
        <h5 class="font-semibold text-gray-800 mb-4">📋 Resumen de la Transacción</h5>
        <div class="grid grid-cols-1 md:grid-cols-2 gap-4 text-sm">
          <div>
            <span class="font-medium text-gray-600">Tipo de Pagador:</span>
            <div class="font-semibold">{{ getPayerTypeDisplayName() }}</div>
          </div>
          <div *ngIf="getSelectedParticipant()">
            <span class="font-medium text-gray-600">Estudiante:</span>
            <div class="font-semibold">{{ getSelectedParticipant()?.label }}</div>
          </div>
          <div *ngIf="getSelectedCompany()">
            <span class="font-medium text-gray-600">Empresa:</span>
            <div class="font-semibold">{{ getSelectedCompany()?.label }}</div>
          </div>
          <div>
            <span class="font-medium text-gray-600">Concepto:</span>
            <div class="font-semibold">{{ getSelectedConceptLabel() }}</div>
          </div>
          <div>
            <span class="font-medium text-gray-600">Método de Pago:</span>
            <div class="font-semibold">{{ getSelectedPaymentMethodName() }}</div>
          </div>
          <div>
            <span class="font-medium text-gray-600">Monto a Pagar:</span>
            <div class="font-semibold text-green-600">{{ getFormattedGrossAmount() }}</div>
          </div>
        </div>
      </div>
    </div>

    <!-- STEP 4: Pantalla de Éxito - Comprobantes Generados -->
    <div *ngIf="step === 4 && showCreationResult && creationResult" class="bg-white p-6 rounded-lg shadow-sm mb-6">
      <div class="flex items-center mb-6">
        <div class="w-2 h-8 bg-green-500 rounded mr-3"></div>
        <h3 class="text-lg font-semibold text-gray-800">Comprobantes de Ingreso Generados</h3>
      </div>

      <!-- Mensaje de éxito -->
      <div class="bg-gradient-to-r from-green-50 to-emerald-50 p-6 rounded-xl border border-green-200 mb-6">
        <div class="flex items-center mb-4">
          <div class="w-12 h-12 bg-green-500 rounded-full flex items-center justify-center mr-4">
            <svg class="w-6 h-6 text-white" fill="currentColor" viewBox="0 0 20 20">
              <path fill-rule="evenodd"
                d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                clip-rule="evenodd"></path>
            </svg>
          </div>
          <div>
            <h4 class="text-xl font-bold text-green-800">Pago procesado exitosamente</h4>
            <p class="text-sm text-green-700">
              Se generaron <strong>{{ creationResult.totalReceiptsGenerated }}</strong> comprobante(s) de ingreso
            </p>
          </div>
        </div>

        <!-- Resumen general -->
        <div class="grid grid-cols-1 md:grid-cols-3 gap-4 mt-4">
          <div class="bg-white p-4 rounded-lg shadow-sm text-center">
            <div class="text-2xl font-bold text-green-600">{{ creationResult.totalReceiptsGenerated }}</div>
            <div class="text-sm text-gray-600">Comprobantes Generados</div>
          </div>
          <div class="bg-white p-4 rounded-lg shadow-sm text-center">
            <div class="text-2xl font-bold text-blue-600">{{ creationResult.totalAmountApplied | currency:'COP':'symbol-narrow':'1.0-0' }}</div>
            <div class="text-sm text-gray-600">Monto Total Aplicado</div>
          </div>
          <div class="bg-white p-4 rounded-lg shadow-sm text-center">
            <div class="text-xs font-mono text-gray-500 break-all">{{ creationResult.paymentGroupId }}</div>
            <div class="text-sm text-gray-600 mt-1">ID de Grupo de Pago</div>
          </div>
        </div>
      </div>

      <!-- Tabla de detalle de comprobantes -->
      <div class="bg-white rounded-lg border border-gray-200 overflow-hidden mb-6">
        <div class="bg-gray-50 px-6 py-3 border-b border-gray-200">
          <h5 class="font-semibold text-gray-800">Detalle de Comprobantes</h5>
        </div>
        <div class="overflow-x-auto">
          <table class="w-full text-sm">
            <thead>
              <tr class="bg-gray-50 text-left text-gray-600 border-b">
                <th class="px-6 py-3 font-semibold">No. Comprobante</th>
                <th class="px-6 py-3 font-semibold">Cuota</th>
                <th class="px-6 py-3 font-semibold">Concepto</th>
                <th class="px-6 py-3 font-semibold text-right">Monto Bruto</th>
                <th class="px-6 py-3 font-semibold text-right">Monto Neto</th>
                <th class="px-6 py-3 font-semibold text-center">Estado Cuota</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let receipt of creationResult.generatedReceipts; let i = index"
                class="border-b border-gray-100 hover:bg-gray-50">
                <td class="px-6 py-3 font-semibold text-blue-600">{{ receipt.id }}</td>
                <td class="px-6 py-3">
                  <span *ngIf="receipt.installmentNumber" class="bg-blue-100 text-blue-800 px-2 py-1 rounded-full text-xs font-medium">
                    Cuota {{ receipt.installmentNumber }}
                  </span>
                  <span *ngIf="!receipt.installmentNumber" class="text-gray-400">-</span>
                </td>
                <td class="px-6 py-3 text-gray-700 max-w-xs truncate">{{ receipt.concept }}</td>
                <td class="px-6 py-3 text-right font-semibold">{{ receipt.grossAmount | currency:'COP':'symbol-narrow':'1.0-0' }}</td>
                <td class="px-6 py-3 text-right font-semibold text-green-600">{{ receipt.netAmount | currency:'COP':'symbol-narrow':'1.0-0' }}</td>
                <td class="px-6 py-3 text-center">
                  <span class="px-2 py-1 rounded-full text-xs font-medium"
                    [ngClass]="{
                      'bg-green-100 text-green-800': receipt.paymentStatus === 'PAID',
                      'bg-yellow-100 text-yellow-800': receipt.paymentStatus === 'PARTIALLY_PAID',
                      'bg-gray-100 text-gray-600': receipt.paymentStatus !== 'PAID' && receipt.paymentStatus !== 'PARTIALLY_PAID'
                    }">
                    {{ receipt.paymentStatus === 'PAID' ? 'Pagada' : (receipt.paymentStatus === 'PARTIALLY_PAID' ? 'Pago Parcial' : receipt.paymentStatus) }}
                  </span>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <!-- Información adicional del pago -->
      <div class="bg-gray-50 p-6 rounded-lg border border-gray-200">
        <h5 class="font-semibold text-gray-800 mb-4">Información del Pago</h5>
        <div class="grid grid-cols-1 md:grid-cols-2 gap-4 text-sm">
          <div>
            <span class="font-medium text-gray-600">Tipo de Pagador:</span>
            <div class="font-semibold">{{ getPayerTypeDisplayName() }}</div>
          </div>
          <div *ngIf="getSelectedParticipant()">
            <span class="font-medium text-gray-600">Estudiante:</span>
            <div class="font-semibold">{{ getSelectedParticipant()?.label }}</div>
          </div>
          <div *ngIf="getSelectedCompany()">
            <span class="font-medium text-gray-600">Empresa:</span>
            <div class="font-semibold">{{ getSelectedCompany()?.label }}</div>
          </div>
          <div>
            <span class="font-medium text-gray-600">Método de Pago:</span>
            <div class="font-semibold">{{ getSelectedPaymentMethodName() }}</div>
          </div>
          <div>
            <span class="font-medium text-gray-600">Banco:</span>
            <div class="font-semibold">{{ getSelectedBankLabel() }}</div>
          </div>
          <div>
            <span class="font-medium text-gray-600">Monto Total del Pago:</span>
            <div class="font-semibold text-green-600">{{ getFormattedGrossAmount() }}</div>
          </div>
        </div>
      </div>
    </div>

    <!-- Navegación del wizard -->
    <div class="flex justify-between items-center mt-8 pt-6 border-t border-gray-200">

      <!-- NAVEGACIÓN NORMAL (Pasos 1-3) -->
      <ng-container *ngIf="step <= 3">
        <!-- Botón Atrás -->
        <button *ngIf="step > 1" type="button" (click)="goToStep(step - 1)"
          class="bg-gray-500 hover:bg-gray-600 text-white font-semibold px-6 py-3 rounded-lg transition-colors duration-200 flex items-center gap-2">
          <svg class="w-4 h-4" fill="currentColor" viewBox="0 0 20 20">
            <path fill-rule="evenodd"
              d="M12.707 5.293a1 1 0 010 1.414L9.414 10l3.293 3.293a1 1 0 01-1.414 1.414l-4-4a1 1 0 010-1.414l4-4a1 1 0 011.414 0z"
              clip-rule="evenodd"></path>
          </svg>
          Atrás
        </button>

        <!-- Espaciador cuando no hay botón atrás -->
        <div *ngIf="step === 1"></div>

        <!-- Botón Siguiente (Steps 1, 2) -->
        <button *ngIf="step < 3" type="button" [disabled]="!isCurrentStepValid()" (click)="goToStep(step + 1)"
          class="bg-blue-500 hover:bg-blue-600 disabled:bg-gray-300 disabled:cursor-not-allowed text-white font-semibold px-6 py-3 rounded-lg transition-colors duration-200 flex items-center gap-2">
          {{ step === 2 ? 'Ver Resumen' : 'Siguiente' }}
          <svg class="w-4 h-4" fill="currentColor" viewBox="0 0 20 20">
            <path fill-rule="evenodd"
              d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z"
              clip-rule="evenodd"></path>
          </svg>
        </button>

        <!-- Botón Crear Comprobante/Link (Step 3) -->
        <button *ngIf="step === 3" type="submit"
          [disabled]="!isCurrentStepValid() || incomeReceiptForm.invalid || (isEditMode && editJustification.length === 0)"
          class="bg-green-600 hover:bg-green-700 disabled:bg-gray-300 disabled:cursor-not-allowed text-white font-semibold px-8 py-3 rounded-lg transition-all duration-200 transform hover:scale-105 disabled:scale-100 flex items-center gap-2 shadow-lg"
          [ngClass]="{'bg-orange-600 hover:bg-orange-700': isEditMode}">
          <svg class="w-5 h-5" fill="currentColor" viewBox="0 0 20 20">
            <path fill-rule="evenodd"
              d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
              clip-rule="evenodd"></path>
          </svg>
          <ng-container *ngIf="isEditMode; else normalSubmitTemplate">Enviar Edición para Aprobación</ng-container>
          <ng-template #normalSubmitTemplate>
            <div *ngIf="isLinkPayment(); else saveTemplate">Crear Link de Pago</div>
            <ng-template #saveTemplate>Crear Comprobante</ng-template>
          </ng-template>
        </button>
      </ng-container>

      <!-- NAVEGACIÓN ESPECIAL PARA PANTALLA DE ÉXITO (Paso 4) -->
      <ng-container *ngIf="step === 4">
        <div class="flex flex-col md:flex-row gap-4 w-full">
          <!-- Botones para link de pago -->
          <ng-container *ngIf="isLinkGenerated">
            <button type="button" (click)="createAnotherLink()"
              class="flex-1 bg-blue-600 hover:bg-blue-700 text-white font-semibold px-8 py-3 rounded-lg transition-all duration-200 transform hover:scale-105 flex items-center justify-center gap-2 shadow-lg">
              <svg class="w-5 h-5" fill="currentColor" viewBox="0 0 20 20">
                <path fill-rule="evenodd"
                  d="M10 5a1 1 0 011 1v3h3a1 1 0 110 2h-3v3a1 1 0 11-2 0v-3H6a1 1 0 110-2h3V6a1 1 0 011-1z"
                  clip-rule="evenodd"></path>
              </svg>
              Crear Otro Link de Pago
            </button>
          </ng-container>

          <!-- Botón: Ir a lista -->
          <button type="button" (click)="goToIncomeReceiptsList()"
            class="flex-1 bg-gray-600 hover:bg-gray-700 text-white font-semibold px-8 py-3 rounded-lg transition-all duration-200 transform hover:scale-105 flex items-center justify-center gap-2 shadow-lg">
            <svg class="w-5 h-5" fill="currentColor" viewBox="0 0 20 20">
              <path fill-rule="evenodd"
                d="M3 4a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zm0 4a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zm0 4a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zm0 4a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1z"
                clip-rule="evenodd"></path>
            </svg>
            Ver Lista de Comprobantes
          </button>
        </div>
      </ng-container>

    </div>
  </form>
</div>

<!-- Modal de Confirmación -->
<app-confirmation-modal #confirmationModal [isVisible]="showConfirmationModal" [config]="confirmationConfig"
  (confirmed)="onConfirmationModalConfirmed()" (cancelled)="onConfirmationModalCancelled()"
  (closed)="onConfirmationModalClosed()">
</app-confirmation-modal>